import { Link } from "react-router-dom";

const PRODUCTS = [
  {
    nameKo: "서보밸브",
    nameEn: "Servo / Proportional Valves",
    desc: "D661 · D651 · D633 · G761 Series",
    icon: "ri-equalizer-2-line",
    img: "https://static.readdy.ai/image/8ccd4206efe4c67b5e0d83664e55b718/32f8c3414e3954ade2c3caa6020eacfd.png",
    moogUrl: "http://www.imctech.co.kr/product/list.php?cate1=1&cate2=1",
  },
  {
    nameKo: "서보 드라이브 및 모터",
    nameEn: "Servo Drives & Motors",
    desc: "MSD Drive · CD · ExD Servo Motor",
    icon: "ri-flashlight-line",
    img: "https://static.readdy.ai/image/8ccd4206efe4c67b5e0d83664e55b718/e8f47caa7ccb117b510bac7e37d61ec3.png",
    moogUrl: "http://www.imctech.co.kr/product/list.php?cate1=1&cate2=9",
    moogUrl2: "http://www.imctech.co.kr/product/list.php?cate1=1&cate2=10",
    moogLabel2: "MOOG 드라이브 정보",
  },
  {
    nameKo: "모션 컨트롤러",
    nameEn: "Motion Controllers",
    desc: "MSC III · PLC · EtherCAT · I/O",
    icon: "ri-cpu-line",
    img: "https://static.readdy.ai/image/8ccd4206efe4c67b5e0d83664e55b718/d76635f08b5079c1e6e5f6d2789d3a0e.png",
    moogUrl: "http://www.imctech.co.kr/product/list.php?cate1=1&cate2=7",
  },

  {
    nameKo: "매니폴드 및 실린더",
    nameEn: "Manifolds & Cylinders",
    desc: "Manifold Block · Hydraulic Cylinder",
    icon: "ri-stack-line",
    img: "https://static.readdy.ai/image/8ccd4206efe4c67b5e0d83664e55b718/f71ca5731d1929117a3f11cf58285d1f.png",
    moogUrl: "http://www.imctech.co.kr/product/list.php?cate1=4&cate2=6",
  },
  {
    nameKo: "Pan & Tilt Positioners",
    nameEn: "Quickset",
    desc: "Precision Pan & Tilt Positioning Systems",
    icon: "ri-crosshair-line",
    img: "https://storage.helloreaddy.io/project_files/d69eff6a-141f-4a4c-87b1-85937ec8d7bf/73067bc1-b5a8-4c8f-81cb-68438d1135e8_compressed_460b93bf-16a2-4a18-be9f-b1339d5640c8.webp",
    moogUrl: "https://www.quickset.com/products/pan-tilt/",
    moogLabel: "Quickset 공식 제품정보 보기",
  },
];

export default function ProductCategorySection() {
  return (
    <section className="py-20 md:py-28 bg-background-50" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.2em] uppercase text-accent-700 mb-3">
              <span className="w-6 h-px bg-accent-500" />
              Product Categories
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-foreground-950 leading-tight">
              MOOG 기반 정밀{" "}
              <span className="text-primary-700">유압·모션 제어 제품군</span>
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              롤프레스, 산업 압연, 정밀 위치·압력 제어에 필요한 핵심 컴포넌트를
              한 곳에서 공급합니다.
            </p>
          </div>
          <Link
            to="/products"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-700 hover:text-primary-800 whitespace-nowrap cursor-pointer"
          >
            전체 제품 보기
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PRODUCTS.map((p) => (
            <div
              key={p.nameKo}
              className="group bg-background-100 border border-background-200 rounded-xl overflow-hidden hover:border-primary-300 transition-colors flex flex-col"
            >
              <div className={`relative aspect-[4/3] overflow-hidden ${p.nameKo === "Pan & Tilt Positioners" ? "bg-background-950" : "bg-background-200"}`}>
                <img
                  src={p.img}
                  alt={p.nameKo}
                  className={`absolute inset-0 w-full h-full group-hover:scale-105 transition-transform duration-500 ${p.nameKo === "Pan & Tilt Positioners" ? "object-contain" : "object-cover object-top"}`}
                />
                <div className="absolute top-3 left-3 w-9 h-9 rounded-md bg-background-50/95 backdrop-blur flex items-center justify-center">
                  <i className={`${p.icon} text-lg w-5 h-5 flex items-center justify-center text-primary-700`} />
                </div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-base font-heading font-bold text-foreground-950">
                  {p.nameKo}
                </h3>
                <p className="text-[11px] font-medium tracking-wide uppercase text-secondary-500 mt-0.5">
                  {p.nameEn}
                </p>
                <p className="mt-1.5 text-xs text-secondary-700 truncate">
                  {p.desc}
                </p>
                <div className="mt-auto pt-4 flex flex-col gap-2">
                  <Link
                    to="/contact"
                    className="inline-flex items-center justify-center gap-1.5 w-full px-3 py-2 rounded-md bg-primary-600 hover:bg-primary-700 text-background-50 text-xs font-semibold whitespace-nowrap cursor-pointer transition-colors"
                  >
                    <i className="ri-mail-send-line w-3.5 h-3.5 flex items-center justify-center" />
                    MC TECH 견적 문의
                  </Link>
                  {p.moogUrl2 ? (
                    <div className="flex gap-2">
                      <a
                        href={p.moogUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center gap-1.5 flex-1 px-3 py-2 rounded-md bg-background-50 border border-background-200 hover:border-primary-300 text-foreground-800 hover:text-primary-700 text-xs font-semibold whitespace-nowrap cursor-pointer transition-colors"
                      >
                        MOOG 모터 정보
                        <i className="ri-arrow-right-up-line w-3.5 h-3.5 flex items-center justify-center" />
                      </a>
                      <a
                        href={p.moogUrl2}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center justify-center gap-1.5 flex-1 px-3 py-2 rounded-md bg-background-50 border border-background-200 hover:border-primary-300 text-foreground-800 hover:text-primary-700 text-xs font-semibold whitespace-nowrap cursor-pointer transition-colors"
                      >
                        {p.moogLabel2}
                        <i className="ri-arrow-right-up-line w-3.5 h-3.5 flex items-center justify-center" />
                      </a>
                    </div>
                  ) : (
                    <a
                      href={p.moogUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center gap-1.5 w-full px-3 py-2 rounded-md bg-background-50 border border-background-200 hover:border-primary-300 text-foreground-800 hover:text-primary-700 text-xs font-semibold whitespace-nowrap cursor-pointer transition-colors"
                    >
                      {p.moogLabel || "MOOG 공식 제품정보 보기"}
                      <i className="ri-arrow-right-up-line w-3.5 h-3.5 flex items-center justify-center" />
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}